'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Icon } from '@/components/ui/icon';
import { Loading03Icon } from '@/components/ui/icon/glyphs';
import type { TransferStep } from '@/hooks/wallet/use-transfer-usdc';
interface TransferConfirmationStepProps {
  from: string;
  destinationLabel: string;
  amount: string;
}
export function TransferConfirmationStep(t0) {
  const $ = _c(31);
  const {
    from,
    destinationLabel,
    amount
  } = t0;
  const t = useTranslations("wallet.transfer");
  let t1;
  if ($[0] !== t) {
    t1 = t("confirm_from");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className="text-body text-foreground-secondary">{t1}</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== from) {
    t3 = <span className="text-body font-medium">{from}</span>;
    $[4] = from;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <div className="flex items-center justify-between">{t2}{t3}</div>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("confirm_to");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <span className="text-body text-foreground-secondary">{t5}</span>;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== destinationLabel) {
    t7 = <span className="text-body font-medium">{destinationLabel}</span>;
    $[13] = destinationLabel;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <div className="flex items-center justify-between">{t6}{t7}</div>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("confirm_amount");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <span className="text-body text-foreground-secondary">{t9}</span>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== amount) {
    t11 = <span className="text-body font-medium">{amount}</span>;
    $[22] = amount;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t10 || $[25] !== t11) {
    t12 = <div className="flex items-center justify-between">{t10}{t11}</div>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t12 || $[28] !== t4 || $[29] !== t8) {
    t13 = <div className="flex flex-col gap-3 rounded-card border p-4">{t4}{t8}{t12}</div>;
    $[27] = t12;
    $[28] = t4;
    $[29] = t8;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  return t13;
}
export function TransferProcessingStep() {
  const $ = _c(5);
  const t = useTranslations("wallet.transfer");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Icon icon={Loading03Icon} className="size-10 animate-spin text-foreground-secondary motion-reduce:animate-none" aria-hidden="true" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== t) {
    t1 = t("sending");
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <div className="flex flex-col items-center gap-4 py-8">{t0}<p className="text-body text-foreground-secondary">{t1}</p></div>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}
interface TransferResultStepProps {
  step: TransferStep;
  error: string | null;
  signature: string | null;
}
export function TransferResultStep(t0) {
  const $ = _c(11);
  const {
    step,
    error,
    signature
  } = t0;
  const t = useTranslations("wallet.transfer");
  let t1;
  if ($[0] !== signature || $[1] !== step || $[2] !== t) {
    t1 = step === "confirmed" && signature !== null ? <p className="text-body text-foreground-secondary">{t("success_message")}</p> : null;
    $[0] = signature;
    $[1] = step;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== error || $[5] !== step || $[6] !== t) {
    t2 = step === "failed" ? <p className="text-body text-feedback-error-content">{error ?? t("toast_failed")}</p> : null;
    $[4] = error;
    $[5] = step;
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className="flex flex-col gap-4">{t1}{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}